var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { StyledIcon } from '../components/StyledIcon';
export var Valid = forwardRef(function (props, ref) { return (_jsxs(StyledIcon, __assign({ ref: ref, viewBox: "0 0 21 21", a11yTitle: "Valid" }, props, { children: [_jsx("circle", { cx: "10.1712", cy: "10.6558", r: "9.17115", stroke: "#000", strokeWidth: "1.5" }), _jsx("path", { d: "M7.36719 10.8439L9.17664 12.6533L12.8019 9.03442", stroke: "#000", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }))); });
//# sourceMappingURL=Valid.js.map